import React from 'react';
import { useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image';
import { useHistory } from 'react-router-dom';
import {
  getFullAddressDetails,
  getValueOrDefaultAlternativeObject,
  navigateToRestaurantPage,
  checkIfStoreShutDown,
  isFutureTime,
  isFutureDate,
  getValueOrDefaultObject,
} from 'common/utilities/utils';
import { getFacilities } from 'common/utilities/amenities';
import { ButtonComp, ButtonType } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import capitalize from 'lodash/capitalize';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  getKms,
  getStoreDetails,
  hourService,
  hoursText,
  convertTimeString,
  toggleHoursView,
} from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';

const { MORE_INFO, SCHEDULE_ORDER, ORDER_NOW } = TRANSLATE_MAPPING_KEY;

export const isFutureDateTimeOrder = item => {
  return Boolean(isFutureTime(item) || isFutureDate(item));
};

export const getEnableScheduleOrderLocalized = (enableScheduleOrder, enableClickCollectScheduleOrder, localized) => {
  return enableScheduleOrder || (enableClickCollectScheduleOrder && localized);
};

export const getScheduleFutureDateTime = (item, enableScheduleOrder, enableClickCollectScheduleOrder, localized) => {
  return (
    isFutureDateTimeOrder(item) &&
    getEnableScheduleOrderLocalized(enableScheduleOrder, enableClickCollectScheduleOrder, localized)
  );
};

export const getScheduleOrderButtonComponent = (orderNowButtonClickHandler, item) => {
  return (
    <ButtonComp
      data-testid='schedule-order'
      variant={ButtonType.tertiary}
      className={`padding-set wdth-set order-pad ml2 button search-store-card-btn`}
      onClickHandler={event => orderNowButtonClickHandler(event, item, SCHEDULE_ORDER)}
      disabled={!item?.isOpen}
    >
      <span> {translateWithI18Next(SCHEDULE_ORDER)}</span>
    </ButtonComp>
  );
};

const FavouriteStoreCard = props => {
  const tenantReducer = useSelector(data => data.tenantReducer);
  const {
    componentOptions: {
      web: { dispositionConfig: { enableScheduleOrder, enableClickCollectScheduleOrder } = {} } = {},
    } = {},
  } = tenantReducer ?? {};
  const {
    item,
    index,
    classname,
    setStoreInfo,
    showMap,
    removeFromFavoriteHandler,
    orderNowButtonClickHandler,
    cardHeading,
    showAvailableService,
    isMobile,
    showMoreInfo,
    setShowCard,
    showDistance,
    dispositionType,
  } = props;

  const { ORDER_NOW_CTA_TEXT } = SEARCH_STORE_CONSTANTS;
  const serviceType = localStorage.getItem('serviceType');
  const history = useHistory();

  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const { localized = false } = getValueOrDefaultObject(userParams);

  return (
    <React.Fragment>
      <div className={`bgv-set store-card flex-dir ${classname}`}>
        <div className='address-block'>
          <div>
            <div className='card-store-container'>
              <span className='card-store-name card-store-global'>{item?.storeBasic?.dname[0]?.value}</span>
              {showDistance && <span className='store-distance'>{getKms(item?.distance?.value)}</span>}
              {showMap && !showMoreInfo && <span className='store-index fl-rgt'>{cardHeading}</span>}
              {!isMobile && showMap && showMoreInfo && (
                <ImageComponent
                  data-testid='favorite-img'
                  srcFile={IMAGE_PATH.PopupCloseBtn}
                  alt={'close-btn'}
                  className='close-cross-btn'
                  onClick={() => setShowCard(false)}
                />
              )}
              {isMobile && (
                <ImageComponent
                  data-testid='favorite-img'
                  srcFile={IMAGE_PATH.FavoriteFillImage}
                  alt={'favorite'}
                  className='favorite-img fav-img-mobile'
                  onClick={() => removeFromFavoriteHandler(item?.storeBasic?.id)}
                />
              )}
            </div>
            <div className='card-content'>
              <div className='order-items'>{showAvailableService(item?.availableServicesPerChannel)}</div>
              <div className={'w-100'}>
                <span className='store-address'>{getFullAddressDetails(item?.storeBasic?.address[0]?.address)}</span>
                <div className={`info-timing ${!item?.isOpen && !checkIfStoreShutDown(item) && 'info-timingClosed'}`}>
                  <span>{getStoreDetails(item, null, null, dispositionType)?.storeTimeMessage}</span>
                  <span
                    className='ml-2 caretIcon store-timing-msg'
                    data-testid='toggle-hours'
                    onClick={() => toggleHoursView(item?.storeBasic?.id)}
                    id={`hours-${item?.storeBasic?.id}`}
                  >
                    <ImageComponent
                      id={`caret-${item?.storeBasic?.id}`}
                      srcFile={IMAGE_PATH.AccordianArrow}
                      alt='caretIcon'
                    />
                  </span>
                </div>
              </div>

              <div id={`view-${item?.storeBasic?.id}`} className='hours-view hoursHidden'>
                {!!hourService(serviceType, item?.summary?.timings)?.storeTimingData?.length && (
                  <div className='dispotion-hours-text'>{hoursText(serviceType)}</div>
                )}
                {hourService(serviceType, item?.summary?.timings)?.storeTimingData?.map(itemVal => {
                  return (
                    <div key={itemVal?.day}>
                      <div className='hours-text'>
                        <span className='day-details'>{translateWithI18Next(capitalize(itemVal?.day))}</span>
                        <span className='time-details'>
                          {convertTimeString(itemVal?.availableHours?.from)} -{' '}
                          {convertTimeString(itemVal?.availableHours?.to)}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className='more-info-details'>
                <span>
                  <a
                    variant={ButtonType.tertiary}
                    data-testid='more-info'
                    className='more-info-link'
                    onClick={() => navigateToRestaurantPage(props?.item, history)}
                  >
                    {translateWithI18Next(MORE_INFO)}
                  </a>
                </span>
                {!showMap && (
                  <span className='map-link' data-testid='map-handler' onClick={() => setStoreInfo(item, index)}>
                    <img src={IMAGE_PATH.Direction} alt='direction' className='KfcDirectionIcon' />
                    <span className='card-map-link'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.GET_DIRECTION)}</span>
                  </span>
                )}
              </div>
              <div className='facilities'>
                {getFacilities(item?.storeBasic)?.length > 0 &&
                  getFacilities(item?.storeBasic).map(itemVal => {
                    return (
                      <ImageComponent
                        key={itemVal.key}
                        data-testid=''
                        srcFile={itemVal.image}
                        alt={getValueOrDefaultAlternativeObject(itemVal.label, '')}
                        className='facility-img'
                        title={itemVal.label}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        <div className={`button-block align-center mt-2 ${showMap && showMoreInfo ? 'fav-store-block' : ''}`}>
          {!showMap && !isMobile && (
            <span className='flex-dir flex-dir-pos'>
              <ImageComponent
                data-testid='favorite-img'
                srcFile={IMAGE_PATH.FavoriteFillImage}
                alt={'favorite'}
                className='favorite-img'
                onClick={() => removeFromFavoriteHandler(item?.storeBasic?.id)}
              />
            </span>
          )}
          {
            <>
              <ButtonComp
                data-testid='order-now'
                className={`padding-set wdth-set order-pad ml2 button redButton search-store-card-btn`}
                onClickHandler={event => orderNowButtonClickHandler(event, item, ORDER_NOW)}
                disabled={!item?.isOpen}
              >
                {translateWithI18Next(ORDER_NOW_CTA_TEXT)}
              </ButtonComp>
              {getScheduleFutureDateTime(item, enableScheduleOrder, enableClickCollectScheduleOrder, localized) &&
                getScheduleOrderButtonComponent(orderNowButtonClickHandler, item)}
            </>
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default FavouriteStoreCard;
